<template>
  <div>
    <div v-if="!!model.length">
      <time-line class="mt-4">
        <time-line-item
          v-for="(item, index) in model"
          :key="index"
          icon="fa fa-calendar-check"
        >
          <template #date>
            <label class="history-date-title">
              {{
                $formatDate(item.createdDate, $templateDate.numberMonthDayYear)
              }}
            </label>
            <label class="history-date-value">
              {{ $formatDate(item.createdDate, $templateDate.hour) }}
            </label>
          </template>
          <div id="main-info" class="row">
            <div class="col-2 appointment-status">
              <CustomBalloon
                class="px-3 py-2"
                :text="item.appointmentStatusName"
                :background-color="assignColorStatus(item)"
              />
            </div>
            <div class="col-2 item-col">
              <label class="info-field-title">Realizado por:</label>
              <label class="info-field-value">
                {{ item.createdByUser | empty }}
              </label>
            </div>
            <div v-if="hasReasonDescription(item)" class="col-2 item-col">
              <label class="info-field-title">Razón:</label>
              <label class="info-field-value">
                {{ hasReasonDescription(item) | empty }}
              </label>
            </div>
            <div v-if="hasValidStatusForDate(item)" class="col-2 item-col">
              <label class="info-field-title">Fecha:</label>
              <label class="info-field-value">
                {{ $formatDate(item.timeStart, $templateDate.default) }}
              </label>
            </div>
            <div v-if="hasValidStatusForDate(item)" class="col-2 item-col">
              <label class="info-field-title">Desde:</label>
              <label class="info-field-value">
                {{ $formatDate(item.timeStart, $templateDate.hour) }}
              </label>
            </div>
            <div v-if="hasValidStatusForDate(item)" class="col-2 item-col">
              <label class="info-field-title">Hasta:</label>
              <label class="info-field-value">
                {{ $formatDate(item.timeEnd, $templateDate.hour) }}
              </label>
            </div>
            <div
              v-if="hasStatusComment(item)"
              class="col-12 my-3 mx-0 item-col"
            >
              <hr class="separator" />
            </div>
            <div v-if="hasStatusComment(item)" class="col-4 mt-2 item-col">
              <label class="info-field-title">Comentario:</label>
              <label class="info-field-value">
                {{ item.statusComment }}
              </label>
            </div>
          </div>
        </time-line-item>
      </time-line>
    </div>
    <span v-else>
      <i class="fa fa-info-circle mr-2 orange" />
      <span class="title">Sin registros de citas</span>
    </span>
  </div>
</template>
<script>
import { TimeLine, TimeLineItem } from '@/components/common/timeline';
import CustomBalloon from 'custom-balloon';
import {
  appointmentStatusCodes,
  getAppointmentStatusColor as _getAppointmentStatusColor,
} from '@/utils/constants/appointment-status/appointmentStatusCodes';

export default {
  name: 'AppointmentEvaluationHistory',
  data() {
    return {
      invalidStatusCodesForDate: [
        appointmentStatusCodes.canceledDe,
        appointmentStatusCodes.canceledProv,
      ],
    };
  },
  components: {
    TimeLine,
    TimeLineItem,
    CustomBalloon,
  },
  filters: {
    empty: (value) => (value ? value : '-'),
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  methods: {
    hasReasonDescription(item) {
      return item?.appointmentStatusReasonDescr;
    },
    hasValidStatusForDate(item) {
      return !this.invalidStatusCodesForDate.includes(item.appointmentStatusCd);
    },
    hasStatusComment(item) {
      return !!item.statusComment;
    },
    assignColorStatus(item) {
      let hexColor = _getAppointmentStatusColor(
        item?.appointmentStatusCd,
        false
      );
      return hexColor;
    },
  },
  computed: {
    model() {
      return this.items;
    },
  },
};
</script>
<style scoped lang="scss">
$colorGray: #727272;
$colorDarkGray: #11291b;
$colorWhiteSmoke: #eeeeee;
#main-info {
  margin: 0rem 0.625rem;
  border-radius: 0.25rem;
  .appointment-status {
    margin-bottom: 0.875rem;
    strong {
      text-align: left;
      font-family: Lato;
      font-size: 1rem;
      font-weight: bold;
      letter-spacing: 0px;
      color: $colorDarkGray;
      display: block;
    }
  }
}
.bubble-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.7rem;
  border-radius: 3.125rem;
}
.info-field-value {
  text-align: left;
  font: normal normal normal 1rem/1.75rem Lato;
  letter-spacing: 0px;
  color: $colorDarkGray;
  display: block;
}
.info-field-title {
  text-align: left;
  font: normal normal normal 0.875rem/1.75rem Lato;
  letter-spacing: 0px;
  margin: 0;
  color: $colorGray;
}
.history-date-title {
  text-align: left;
  font: Bold 1rem/1.3125rem Lato;
  letter-spacing: 0px;
  color: $colorDarkGray;
}

.history-date-value {
  font: normal normal normal 0.75rem/1.3125rem Lato;
  text-align: left;
  letter-spacing: 0px;
  color: $colorDarkGray;
}
.item-col {
  display: block;
}
.separator {
  border-bottom: 4px solid $colorWhiteSmoke;
  border-top: 0;
  border: 1px solid $colorWhiteSmoke;
  margin: 0;
}
</style>
